__webpack_require__.p = "/durak-game/";